import { render } from "./dataList.vue?vue&type=template&id=832db464&scoped=true"
import script from "./dataList.vue?vue&type=script&lang=js"
export * from "./dataList.vue?vue&type=script&lang=js"

import "./dataList.vue?vue&type=style&index=0&id=832db464&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-832db464"]])

export default __exports__